module.exports = __webpack_public_path__ + "static/media/map.d87bbf60.png";